import { Group, SimpleGrid, Stack, Text, Title } from '@mantine/core'
import { IconCopyCheck, IconPalette } from '@tabler/icons-react'
import { useTranslate } from 'react-admin'
import { useVideoPromotionStore } from '../../../../stores/useVideoPromotionStore'
import { IPromotionElementMode } from '../../../../types/components/VideoPromotion.type'
import { NewPromotionCard } from '../../NewPromotionCard/NewPromotionCard'
import { PromotionChooseLayout } from './PromotionChooseLayout'
import { PromotionCopyVideoEndscreen } from './PromotionCopyVideoEndscreen'

type ConfigTypeOption = 'chooseLayout' | 'copyEndscreen'

export const NewPromotionElementEndscreen = () => {
  const t = useTranslate()
  const videoPromotionStore = useVideoPromotionStore()
  const mode = videoPromotionStore.elementsConfiguration.endScreen.mode

  const configTypeOptions: {
    id: ConfigTypeOption
    mode: IPromotionElementMode
    icon: typeof IconPalette
  }[] = [
    { id: 'chooseLayout', mode: 'custom', icon: IconPalette },
    { id: 'copyEndscreen', mode: 'copyFromVideo', icon: IconCopyCheck },
  ]
  return (
    <>
      <Title order={4} mt="lg">
        {t('pages.videoPromotion.configurationType')}
      </Title>
      <SimpleGrid cols={2} my="sm">
        {configTypeOptions.map(ct => (
          <NewPromotionCard
            key={ct.id}
            active={mode === ct.mode}
            onClick={() => videoPromotionStore.setElementMode('endScreen', ct.mode)}
          >
            <Stack gap="xs" h="100%">
              <Group gap="xs">
                <ct.icon size={18} />
                <Title order={5} size="md" fw={500}>
                  {t(`pages.videoPromotion.endScreen.configs.${ct.id}.title`)}
                </Title>
              </Group>
              <Text size="sm" fw="lighter" c="dimmed">
                {t(`pages.videoPromotion.endScreen.configs.${ct.id}.description`)}
              </Text>
            </Stack>
          </NewPromotionCard>
        ))}
      </SimpleGrid>
      {mode === 'custom' && <PromotionChooseLayout />}
      {mode === 'copyFromVideo' && <PromotionCopyVideoEndscreen />}
    </>
  )
}
